// NEURACOM i18n — locale: pl
// Auto-generated from translations.js refactor (iteration 25).
// Edit by namespace section. Keep keys in sync with en.js + it.js + pl.js.
const pl = {
  common: {
    brand: "NEURACOM",
    brand_by: "by TelcaVoIP",
    get_started: "Rozpocznij",
    sign_in: "Zaloguj się",
    sign_up: "Zarejestruj się",
    sign_out: "Wyloguj",
    dashboard: "Panel",
    pricing: "Cennik",
    features: "Funkcje",
    contact: "Kontakt",
    loading: "Ładowanie...",
    cancel: "Anuluj",
    save: "Zapisz",
    delete: "Usuń",
    try_free: "Wypróbuj za darmo",
    upgrade: "Aktualizuj",
    learn_more: "Dowiedz się więcej",
    coming_soon: "Już wkrótce",
    partner_program: "Program Partnerski",
    close: "Zamknij",
  },
  pwa: {
    install_title: "Zainstaluj NEURACOM",
    install_desc: "Dodaj NEURACOM do ekranu głównego — jednym tapnięciem, działa też offline.",
    install_cta: "Zainstaluj",
    install_later: "Później",
    install_ios_title: "Zainstaluj NEURACOM na iPhone",
    install_ios_step1: "Stuknij",
    install_ios_step2: "następnie",
    install_ios_step3: "Dodaj do ekranu głównego",
    update_title: "Dostępna nowa wersja",
    update_desc: "Załaduj ponownie, aby uzyskać najnowsze funkcje i poprawki.",
    update_reload: "Załaduj ponownie",
    update_later: "Później",
    offline_badge: "Offline",
    offline_toast: "Jesteś offline — niektóre funkcje mogą nie działać.",
    online_toast: "Z powrotem online.",
  },
  download: {
    pretitle: "Zainstaluj jako aplikację",
    title: "Zainstaluj NEURACOM na telefonie",
    subtitle_desktop: "Zeskanuj kod QR aparatem telefonu. Aplikacja instaluje się w 5 sekund — bez App Store, bez Play Store, bez czekania na recenzję.",
    subtitle_mobile: "Dodaj NEURACOM do ekranu głównego. Stuknij przycisk poniżej, a aplikacja zainstaluje się w 5 sekund.",
    chip_no_store: "Bez App Store",
    chip_offline: "Działa offline",
    chip_native: "Natywne doświadczenie",
    chip_size: "Mniej niż 1 MB",
    install_now: "Zainstaluj NEURACOM",
    no_store_note: "Bezpośrednia instalacja · bez recenzji · natychmiastowy dostęp",
    desktop_note: "Po instalacji otrzymasz powiadomienia push, wprowadzanie głosowe offline i szybsze ładowanie.",
    qr_caption_desktop: "Skieruj tu aparat",
    qr_caption_mobile: "Lub zeskanuj z innego urządzenia",
    installed_badge: "Już zainstalowana",
    installed_title: "Gotowe — NEURACOM jest na Twoim ekranie głównym.",
    installed_desc: "Stuknij ikonę na ekranie głównym, aby uruchomić aplikację.",
    ios_title: "Instalacja na iPhone — 3 szybkie kroki",
    ios_step_1: "Stuknij przycisk Udostępnij u dołu Safari",
    ios_step_2: "Przewiń w dół i stuknij",
    ios_add_to_home: "Dodaj do ekranu głównego",
    ios_step_3: "Potwierdź 'Dodaj' w prawym górnym rogu",
  },
  landing: {
    hero_pretitle: "Platforma AI dla firm europejskich",
    hero_title: "Buduj z AI. Wdrażaj wszędzie.",
    hero_subtitle:
      "Czat z wieloma modelami, generowanie obrazów i AI code builder — wszystko w jednym bezpiecznym, wielojęzycznym środowisku. Powered by NEURACOM, by TelcaVoIP.",
    hero_cta_primary: "Zacznij za darmo — bez karty",
    hero_cta_secondary: "Zobacz cennik",
    stat_models: "Modele AI",
    stat_languages: "Języki",
    stat_uptime: "Uptime SLA",
    stat_rulings: "Wybrane orzeczenia",
    stat_gdpr_compact: "EU, GDPR",
    stat_kb: "Prywatne notatki",
    stat_gdpr: "100% zgodne",
    hero_legal_chip: "Szukasz Legal Pro?",
    legal_pretitle: "Legal Pro · Dla prawników i IOD",
    legal_title: "Pierwszy włoski asystent AI prawny trenowany na Cassazione + CGUE.",
    legal_subtitle: "Przestań kopiować odpowiedzi z ChatGPT do swoich pism. NEURACOM Legal Pro rozumuje na bazie 103 wybranych orzeczeń, cytuje Twoją prywatną bazę i pisze prawdziwym włoskim językiem prawnym.",
    legal_feat_jurisprudence_title: "103 orzeczenia bazowe",
    legal_feat_jurisprudence_desc: "Wybrana włoska i europejska jurysprudencja, przeszukiwana natywnym BM25 + auto-cytaty podczas czatu.",
    legal_feat_knowledge_base_title: "Twój prywatny mózg prawny",
    legal_feat_knowledge_base_desc: "Zapisuj orzeczenia, odpowiedzi AI i notatki w zaszyfrowanej osobistej Bazie. Twoja wiedza rośnie z każdą sprawą.",
    legal_feat_auto_cite_title: "Cytowania ambient",
    legal_feat_auto_cite_desc: "Podczas pisania NEURACOM proponuje 3 najtrafniejsze notatki z Twojej Bazy. Tryb Auto-KB dodaje je automatycznie — bez klikania.",
    legal_feat_gdpr_title: "Hosted UE, GDPR by design",
    legal_feat_gdpr_desc: "Dane przetwarzane w UE, izolowane per konto, nigdy używane do trenowania zewnętrznych modeli.",
    legal_workflow_pretitle: "Jak działa Legal Pro",
    legal_workflow_title: "Od research do gotowego briefu w kilka minut.",
    legal_step_1_title: "Zapisz orzeczenia jednym kliknięciem",
    legal_step_1_desc: "Przeglądaj 103 wybrane orzeczenia IT/UE lub wgraj własne PDF. Przypnij zasady, których używasz najczęściej.",
    legal_step_2_title: "Czat w Trybie Prawnym",
    legal_step_2_desc: "Włącz Tryb Prawny. AI cytuje automatycznie odpowiednie orzeczenia z bazy — i z Twojej prywatnej Bazy.",
    legal_step_3_title: "Cytaty dosłowne, żadnych halucynacji",
    legal_step_3_desc: "Każdy cytat jest zakotwiczony w rzeczywistym orzeczeniu lub Twojej notatce. Odpowiedzi zawierają sąd, numer i datę.",
    legal_step_4_title: "Eksportuj do swojego pisma",
    legal_step_4_desc: "Skopiuj odpowiedź do swojego pisma — język jest już w formalnym rejestrze prawnym.",
    legal_quote: "\"Wcześniej spędzałem 40 minut na Italgiure szukając właściwego orzeczenia. Z NEURACOM mam draft z 3 zweryfikowanymi cytatami w 90 sekund.\"",
    legal_quote_author: "Adw. M. (Kancelaria, Mediolan)",
    legal_quote_role: "Prawo cywilne i handlowe · Użytkownik Legal Pro",
    legal_use_contracts: "Umowy",
    legal_use_litigation: "Spory sądowe",
    legal_use_gdpr: "GDPR & Privacy",
    legal_use_labor: "Prawo pracy",
    legal_use_tax: "Prawo podatkowe",
    legal_use_real_estate: "Nieruchomości",
    legal_price_unit: "/ miesiąc · anuluj kiedy chcesz",
    legal_price_note: "Zawiera Claude Opus 4.8, 1.000 wiadomości czatu/mies., 100 PDF, nielimitowane notatki KB.",
    legal_cta_primary: "Rozpocznij Legal Pro",
    legal_cta_secondary: "Porównaj plany",
    features_title: "Jedno miejsce. Każde zadanie AI.",
    features_subtitle:
      "Koniec z żonglowaniem kartami. NEURACOM daje Twojemu zespołowi Claude, GPT, Gemini, generowanie obrazów i AI code builder w jednej brandowanej platformie.",
    feat_chat_title: "Czat AI z wieloma modelami",
    feat_chat_desc:
      "Przełączaj między Claude Sonnet 4.5, GPT-5.2 i Gemini 3 Flash w jednym czacie. Wybierz odpowiedni mózg do zadania.",
    feat_image_title: "Studio generowania obrazów",
    feat_image_desc:
      "Twórz wspaniałe wizualizacje z Gemini Nano Banana i OpenAI GPT-Image-1. Marketing, mockupy, social.",
    feat_code_title: "AI Code Builder",
    feat_code_desc:
      "Opisz aplikację w swoim języku. Otrzymaj pełny plik HTML/CSS/JS z podglądem i pobieraniem ZIP.",
    feat_quotas_title: "Przejrzyste limity",
    feat_quotas_desc:
      "Jasne miesięczne limity na plan. Bez niespodzianek. Aktualizuj tylko, gdy potrzebujesz.",
    feat_secure_title: "Prywatność na poziomie UE",
    feat_secure_desc:
      "Twoje dane należą do Ciebie. Szyfrowane w tranzycie i spoczynku. Zgodne z RODO.",
    feat_multilang_title: "Interfejs trójjęzyczny",
    feat_multilang_desc:
      "Włoski, angielski, polski — automatycznie wykrywany. Bez konfiguracji.",
    voice_pretitle: "Nowość — wejście głosowe",
    voice_title: "Mów do NEURACOM. W swoim języku.",
    voice_subtitle:
      "Dotknij mikrofonu, podyktuj polecenie, a OpenAI Whisper zamieni Twój głos w idealny tekst — automatycznie. Bez konfiguracji, bez aplikacji, bez narzędzi do transkrypcji.",
    voice_bullet_languages: "Wykrywa włoski, angielski i polski automatycznie — bez ręcznego wyboru",
    voice_bullet_fast: "Whisper-1 przetwarza typowy 30-sekundowy klip w mniej niż 3 sekundy",
    voice_bullet_private: "Audio przetwarzane przejściowo, nigdy nie zapisywane — zgodne z RODO",
    voice_cta_primary: "Wypróbuj czat głosowy za darmo",
    voice_cta_note: "Bez karty kredytowej",
    voice_transcript_label: "Transkrypcja na żywo",
    voice_transcript_example: "„Napisz przyjazny e-mail z aktualizacją produktu, maksymalnie jeden akapit.”",
    cta_title: "Gotowy budować z AI?",
    cta_subtitle:
      "Zacznij za darmo dziś. Zaktualizuj dopiero, gdy wdrożysz coś prawdziwego.",
    cta_button: "Załóż konto",
  },
  pricing: {
    title: "Proste, przejrzyste ceny",
    subtitle: "Wybierz plan dopasowany do Twojego użycia. Anuluj w każdej chwili.",
    per_month: "/miesiąc",
    most_popular: "NAJPOPULARNIEJSZY",
    cta_free: "Zacznij za darmo",
    cta_paid: "Subskrybuj",
    current_plan: "Aktualny plan",
    cycle_monthly: "Miesięcznie",
    cycle_annual: "Rocznie",
    cycle_save_badge: "Oszczędź 2 miesiące",
    annual_total: "€{total}/rok — oszczędność €{saved} vs miesięczny",
    promo_first_month_note: "Tylko pierwszy miesiąc — €{price}/miesiąc później",
    promo_cleared_annual: "Kody promocyjne dotyczą tylko płatności miesięcznych — plan roczny już zawiera zniżkę.",
    err_PROMO_NOT_VALID_FOR_ANNUAL: "Kody promocyjne dotyczą tylko miesięcznego rozliczenia. Przełącz na miesięczne, aby użyć promo.",
    free_name: "Free",
    free_price: "€0",
    free_tagline: "Wypróbuj platformę",
    starter_name: "Starter",
    starter_tagline: "Dla twórców indywidualnych",
    pro_name: "Pro",
    pro_tagline: "Dla freelancerów i małych zespołów",
    business_name: "Business",
    business_tagline: "Dla agencji i firm",
    legal_specialized: "Wyspecjalizowana wertykała",
    legal_pro_name: "Legal Pro",
    legal_pro_tagline: "Dla prawników, doradców i DPO. Wyspecjalizowany asystent w prawie włoskim i UE, z priorytetowym dostępem do najpotężniejszego modelu wnioskowania.",
    legal_pro_target: "Dla: prawników, księgowych, HR managerów, DPO, in-house legal counsel.",
    legal_pro_cta: "Przejdź na Legal Pro",
    legal_pro_feature_quota: "8 000 wiadomości AI, 300 obrazów, 100 projektów code, 50 PDF Q&A miesięcznie",
    legal_pro_feature_opus: "Priorytetowy dostęp do Claude Opus 4.8 i Fable 5 (beta) — 1M kontekst do wnioskowania prawnego",
    legal_pro_feature_default_on: "Tryb prawny aktywny domyślnie na każdej nowej rozmowie",
    legal_pro_feature_templates: "7 gotowych szablonów prawnych (NDA, informacja RODO, umowy doradcze, T&C e-commerce…)",
    legal_pro_feature_rag: "Automatyczna analiza klauzula-po-klauzuli przesłanych umów (PDF Q&A) + 103 wybrane orzeczenia",
    legal_pro_feature_kb: "Osobista Baza Wiedzy Prawnej z cytatami ambient Auto-KB",
    legal_pro_feature_priority: "Priorytetowe wsparcie i odpowiedzi",
    feat_msgs: "{n} wiadomości czatu AI/miesiąc",
    feat_imgs: "{n} wygenerowanych obrazów/miesiąc",
    feat_code: "{n} projektów code/miesiąc",
    feat_models: "Wiele modeli: Claude, GPT, Gemini",
    feat_priority: "Wsparcie priorytetowe",
    feat_email: "Wsparcie e-mailowe",
    feat_history: "Pełna historia zachowana",
    feat_api: "Dostęp do API (tylko Business)",
    promo_label: "Masz kod promocyjny?",
    promo_placeholder: "LAUNCH2026",
    promo_apply: "Zastosuj",
    promo_clear: "Wyczyść",
    promo_applied: "✓ Promocja zastosowana — Pro pierwszy miesiąc za €{price}",
    promo_banner_title: "🚀 Promocja na start — pierwszy miesiąc Pro za €9",
    promo_banner_subtitle: "Użyj kodu {code}. Limit dla pierwszych 100 subskrybentów (pozostało {remaining}).",
    err_PROMO_INVALID_CODE: "Nieprawidłowy kod promocyjny.",
    err_PROMO_PLAN_MISMATCH: "Ten kod jest ważny tylko dla planu Pro.",
    err_PROMO_EXHAUSTED: "Przepraszamy — ta promocja została wyczerpana.",
  },
  auth: {
    welcome_back: "Witaj ponownie",
    welcome_new: "Załóż konto NEURACOM",
    email_label: "E-mail",
    password_label: "Hasło",
    name_label: "Twoje imię (opcjonalnie)",
    sign_in_btn: "Zaloguj się",
    sign_up_btn: "Załóż konto",
    google_btn: "Kontynuuj z Google",
    have_account: "Masz już konto?",
    no_account: "Nie masz jeszcze konta?",
    or_divider: "lub",
    password_hint: "Min. 8 znaków",
    err_AUTH_INVALID_CREDENTIALS: "Nieprawidłowy e-mail lub hasło.",
    err_AUTH_EMAIL_ALREADY_REGISTERED: "Ten e-mail jest już zarejestrowany.",
    err_AUTH_EMERGENT_NO_EMAIL: "Logowanie Google nieudane — brak e-maila.",
    err_AUTH_EMERGENT_INVALID_SESSION: "Sesja Google wygasła.",
    err_AUTH_NOT_AUTHENTICATED: "Zaloguj się, aby kontynuować.",
    err_AUTH_INVALID_TOKEN: "Twoja sesja wygasła. Zaloguj się ponownie.",
    err_UNKNOWN_ERROR: "Wystąpił nieznany błąd. Spróbuj ponownie.",
  },
  dashboard: {
    welcome: "Witaj ponownie",
    current_plan: "Bieżący plan",
    usage_overview: "Użycie w okresie",
    messages_used: "Wiadomości czatu",
    images_used: "Wygenerowane obrazy",
    code_used: "Projekty code",
    quick_actions: "Szybkie akcje",
    action_chat: "Rozpocznij nowy czat",
    action_image: "Wygeneruj obraz",
    action_code: "Buduj z AI",
    recent_chats: "Ostatnie rozmowy",
    recent_images: "Ostatnie obrazy",
    no_activity: "Brak aktywności. Zacznij powyżej.",
    upgrade_cta: "Przejdź na {plan}, aby uzyskać więcej",
    tier_free: "Free",
    tier_starter: "Starter",
    tier_pro: "Pro",
    tier_business: "Business",
  },
  chat: {
    new_chat: "Nowy czat",
    conversations: "Rozmowy",
    placeholder: "Zapytaj o cokolwiek…",
    send: "Wyślij",
    model: "Model",
    thinking: "Myślę…",
    model_claude: "Claude Sonnet 4.5",
    model_gpt: "GPT-5.2",
    model_gemini: "Gemini 3 Flash",
    group_claude: "Anthropic — Claude",
    group_openai: "OpenAI",
    group_gemini: "Google — Gemini",
    model_claude_sonnet: "Claude Sonnet 4.5 — Zbalansowany",
    model_claude_sonnet_46: "Claude Sonnet 4.6 — Najlepiej zbalansowany",
    model_claude_opus_48: "Claude Opus 4.8 — Rozumowanie flagship",
    model_claude_fable_5: "Claude Fable 5 — 1M kontekst (beta)",
    model_fallback_toast: "{from} jeszcze niedostępny — używam {to} zamiast",
    model_claude_haiku: "Claude Haiku 4.5 — Szybki",
    model_claude_opus: "Claude Opus 4.5 — Maks. jakość",
    model_gpt_52: "GPT-5.2 — Najnowszy",
    model_gpt_4o: "GPT-4o — Multimodalny",
    model_gpt_41_mini: "GPT-4.1 Mini — Szybki",
    model_gemini_flash: "Gemini 3 Flash — Szybki",
    model_gemini_pro: "Gemini 3.1 Pro — Długi kontekst",
    mic_start: "Mów do NEURACOM",
    mic_stop: "Zatrzymaj i transkrybuj",
    mic_transcribing: "Trwa transkrypcja…",
    mic_denied: "Brak zgody na mikrofon. Włącz dostęp w przeglądarce, aby dyktować.",
    mic_unsupported: "Twoja przeglądarka nie obsługuje wprowadzania głosowego.",
    mic_too_short: "Nagranie zbyt krótkie — trzymaj dłużej.",
    mic_no_speech: "Nie wykryto mowy. Spróbuj ponownie.",
    mic_no_device: "Nie znaleziono mikrofonu na tym urządzeniu.",
    mic_failed: "Nie udało się transkrybować audio. Spróbuj ponownie.",
    err_STT_UNSUPPORTED_FORMAT: "Format audio nieobsługiwany.",
    err_STT_FILE_TOO_LARGE: "Plik audio zbyt duży (maks. 25 MB).",
    err_STT_PROVIDER_ERROR: "Błąd usługi transkrypcji głosowej. Spróbuj później.",
    err_STT_EMPTY_FILE: "Plik audio jest pusty.",
    no_messages: "Rozpocznij rozmowę. Przełączaj modele w każdej chwili.",
    delete_confirm: "Usunąć tę rozmowę?",
    smart_chips_title: "Szybki start",
    smart_chips_hint: "Wybierz zadanie, aby przekierować do najlepszego mózgu AI — albo po prostu pisz.",
    smart_chip_write_title: "Pisz",
    smart_chip_write_desc: "E-maile, posty, copy. Routing do GPT.",
    smart_chip_write_prompt: "Pomóż mi napisać jasny, przekonujący e-mail do ",
    smart_chip_code_title: "Kod",
    smart_chip_code_desc: "Debug, refactor, wyjaśnienia. Routing do Claude.",
    smart_chip_code_prompt: "Pomóż mi z tym kodem — wyjaśnij, co robi i jak go poprawić:\n\n```\n\n```",
    smart_chip_analyze_title: "Analizuj",
    smart_chip_analyze_desc: "Rozumowanie, porównania, decyzje. Routing do Claude.",
    smart_chip_analyze_prompt: "Przeanalizuj poniższe i daj mi plusy, minusy i rekomendację:\n\n",
    smart_chip_brainstorm_title: "Burza mózgów",
    smart_chip_brainstorm_desc: "Pomysły, nazwy, ujęcia. Routing do GPT.",
    smart_chip_brainstorm_prompt: "Wymyśl 10 kreatywnych pomysłów na ",
    smart_chip_image_title: "Opisz obraz",
    smart_chip_image_desc: "Rozumienie multimodalne. Routing do Gemini.",
    smart_chip_image_prompt: "Zaraz opiszę obraz (lub wkleję link). Pomóż mi napisać szczegółowy alt-text i marketingowy podpis: ",
    smart_chip_research_title: "Badanie",
    smart_chip_research_desc: "Źródła, streszczenia, długie dokumenty. Routing do Gemini.",
    smart_chip_research_prompt: "Zbadaj i streść najnowsze informacje o ",
    brain_hint_code: "To wygląda na kod — przy programowaniu {brain} daje precyzyjniejsze odpowiedzi.",
    brain_hint_analyze: "Wymaga uważnego rozumowania — {brain} świetnie radzi sobie z analizą krok po kroku.",
    brain_hint_research: "Wygląda na zadanie badawcze — {brain} dobrze obsługuje długi kontekst i źródła.",
    brain_hint_creative: "To zadanie kreatywne — {brain} pisze bardziej naturalne teksty.",
    brain_hint_switch: "Przełącz na {brain}",
    help_which_brain: "Który mózg?",
    legal_mode_on: "Tryb prawny WŁ",
    legal_mode_off: "Tryb prawny",
    legal_mode_active: "Tryb prawny aktywny — wyspecjalizowany asystent IT/UE",
    legal_mode_inactive: "Kliknij, aby włączyć wyspecjalizowanego doradcę prawnego (IT/UE)",
    legal_short: "Prawny",
    legal_disclaimer: "Tryb prawny aktywny: wyspecjalizowany asystent w zakresie prawa włoskiego i UE. Odpowiedzi mają charakter informacyjny i NIE zastępują wykwalifikowanego prawnika ani DPO.",
    kb_context_title: "Aktywny kontekst Bazy · {count}",
    kb_context_clear: "Wyczyść wszystkie",
    kb_context_hint: "Te notatki z Twojej osobistej Bazy Wiedzy zostaną wysłane jako kontekst dla następnej wiadomości.",
    kb_suggest_title: "Sugerowane z Twojej Bazy",
    kb_suggest_include: "Dołącz",
    kb_suggest_dismiss: "Odrzuć",
    kb_suggest_added: "Notatka dodana do kontekstu czatu",
    auto_include_on: "Auto-KB",
    auto_include_off: "Auto-KB",
    auto_short: "AI",
    auto_include_active: "Auto-dołącz WŁ — serwer wybiera top-3 notatki dla każdej wiadomości",
    auto_include_inactive: "Auto-dołącz WYŁ — kliknij, aby aktywować automatyczny kontekst Bazy",
    auto_include_banner: "Auto-KB aktywne — top-3 notatki z Twojej Bazy zostaną wstrzyknięte automatycznie do następnej wiadomości.",
    legal_templates_title: "Szablony:",
    legal_templates: {
      consulting_label: "Umowa doradcza",
      consulting_prompt: "Sporządź profesjonalną umowę doradczą pomiędzy włoską Srl (zleceniodawca) a niezależnym konsultantem (consulente) na usługi doradztwa IT. Zawrzyj: strony, przedmiot, czas trwania 12 miesięcy z automatycznym odnowieniem, wynagrodzenie (€X/godz. + miesięczny limit), klauzulę poufności, przeniesienie IP, klauzulę GDPR podmiotu przetwarzającego (art. 28), rozwiązanie z ważnego powodu, jurysdykcję włoską.",
      nda_label: "NDA / Poufność",
      nda_prompt: "Sporządź wzajemne NDA (dwustronne) zgodnie z prawem włoskim między dwiema spółkami Srl na fazę negocjacji handlowej. Zawrzyj: definicję 'Informacji Poufnych', wyłączenia, czas 5 lat, obowiązek zwrotu/zniszczenia, karę €50 000 za każde naruszenie, jurysdykcję wyłączną Mediolan, plus odniesienie do art. 28 GDPR jeśli wymieniane są dane osobowe.",
      privacy_gdpr_label: "Klauzula informacyjna RODO (art. 13)",
      privacy_gdpr_prompt: "Sporządź klauzulę informacyjną z art. 13 RODO dla strony e-commerce B2C. Obejmij: tożsamość administratora, kontakt IOD (jeśli wyznaczony), kategorie danych, podstawy prawne (art. 6 RODO), odbiorców, okresy przechowywania, transfery do państw trzecich (art. 44 nast.), prawa osoby (art. 15-22), prawo skargi do Garante Privacy, profilowanie/zautomatyzowane decyzje wg art. 22.",
      ecommerce_tc_label: "Regulamin e-commerce (B2C)",
      ecommerce_tc_prompt: "Sporządź włoski regulamin B2C dla sklepu e-commerce z elektroniką użytkową. Obejmij: strony, zawarcie umowy, cenę/VAT, płatność, wysyłkę/dostawę, ustawowe prawo odstąpienia (art. 52 Codice del Consumo, 14 dni), gwarancję ustawową (art. 130-135 Codice del Consumo, 24 miesiące), ograniczenia odpowiedzialności, link platformy ODR, sąd konsumenta wg art. 33 D.Lgs. 206/2005.",
      diffida_label: "Wezwanie do zapłaty",
      diffida_prompt: "Sporządź formalne wezwanie do zapłaty (lettera di diffida ad adempiere ex art. 1454 c.c.) do włoskiej Srl, która nie zapłaciła faktury €X w terminie. Wyznacz 15 dni na wykonanie, powołaj się na umowę, oblicz odsetki ustawowe za opóźnienie wg D.Lgs. 231/2002 dla B2B, ostrzeż, że po terminie umowa zostanie rozwiązana ipso iure i zostaną podjęte kroki sądowe.",
      disdetta_locazione_label: "Wypowiedzenie najmu",
      disdetta_locazione_prompt: "Sporządź wypowiedzenie umowy najmu mieszkalnego 4+4 wg L. 431/1998 we Włoszech ze strony najemcy, z wymaganym 6-miesięcznym wypowiedzeniem. Zawrzyj adres nieruchomości, dane rejestracji umowy, żądaną datę zakończenia, ewentualne 'gravi motivi' ex art. 3 L. 431/1998 jeśli dotyczy, oraz prośbę o spotkanie w celu ostatecznego odczytu liczników.",
      disciplinare_label: "Wniosek dyscyplinarny (Art. 7 St. Lav.)",
      disciplinare_prompt: "Sporządź list kwestionujący zachowanie pracownika dyscyplinarnie wg Art. 7 L. 300/1970 (Statuto dei Lavoratori) i obowiązującego CCNL. Wskaż konkretne fakty (data, godzina, miejsce, świadkowie), naruszone klauzule, przyznaj 5-dniowy okres na pisemne wyjaśnienia i przypomnij prawo pracownika do bycia wysłuchanym przy obecności związków zawodowych.",
    },
    err_QUOTA_MESSAGES_EXCEEDED: "Osiągnięto miesięczny limit wiadomości. Zaktualizuj plan.",
    err_LLM_PROVIDER_ERROR: "Błąd dostawcy AI. Spróbuj inny model.",
  },
  brains: {
    back: "← Powrót do czatu",
    pretitle: "Modele AI · Jak wybrać",
    title: "Trzy mózgi. Jedna subskrypcja.",
    subtitle: "Każdy model ma swoją osobowość. Wybierz pasujący do zadania — albo pozwól NEURACOM polecić Ci automatycznie.",
    strengths: "Mocne strony",
    try_example: "Wypróbuj ten przykład",
    pick_btn: "Użyj tego mózgu teraz",
    col_dimension: "Wymiar",
    row_best_for: "Idealny do",
    row_speed: "Szybkość",
    row_context: "Okno kontekstu",
    row_languages: "Języki",
    row_style: "Styl",
    claude: {
      tagline: "Precyzyjny myśliciel",
      strength_1: "Pisanie i wyjaśnianie kodu z chirurgiczną precyzją",
      strength_2: "Długie rozumowanie, umowy, analizy prawne",
      strength_3: "Grzecznie odmawia, gdy coś się nie zgadza — mniej halucynacji",
      strength_4: "Wyjaśnienia krok po kroku, które wytrzymują weryfikację",
      example: "Przejrzyj tę funkcję Pythona pod kątem błędów i powiedz, jak ją zrefaktoryzować dla przejrzystości.",
      best_for: "Kod, umowy, rozumowanie",
      speed: "Średnia",
      context: "200K tokenów",
      languages: "Doskonały IT/EN/PL",
      style: "Wnikliwy, ustrukturyzowany",
    },
    gpt: {
      tagline: "Naturalny pisarz",
      strength_1: "Copywriting marketingowy, e-maile i posty brzmiące naturalnie",
      strength_2: "Szybka burza mózgów wielu alternatyw",
      strength_3: "Asystent ogólnego przeznaczenia — szeroka wiedza",
      strength_4: "Przyjazny ton konwersacyjny od razu",
      example: "Napisz 5 różnych wariantów tematu maila promującego naszą nową platformę AI.",
      best_for: "Pisanie, burza mózgów, ogólne",
      speed: "Szybki",
      context: "128K tokenów",
      languages: "Doskonały IT/EN/PL",
      style: "Naturalny, przyjazny",
    },
    gemini: {
      tagline: "Multimodalny badacz",
      strength_1: "Rozumienie obrazów i treści wizualnych",
      strength_2: "Przetwarzanie ogromnych dokumentów — igła w stogu siana",
      strength_3: "Aktualna wiedza o świecie i synteza badań",
      strength_4: "Świetnie radzi sobie z danymi strukturalnymi, tabelami",
      example: "Streść kluczowe wyniki tego 80-stronicowego PDF i zacytuj najważniejszy fragment.",
      best_for: "Multimodalne, długie badania",
      speed: "Szybki",
      context: "2M tokenów",
      languages: "Doskonały IT/EN/PL",
      style: "Faktyczny, kompletny",
    },
    reassure_switch_title: "Zmień w dowolnej chwili",
    reassure_switch_desc: "Zmień mózg w trakcie rozmowy. Zachowujemy kontekst.",
    reassure_auto_title: "Inteligentne auto-routowanie",
    reassure_auto_desc: "Pisz swobodnie — podpowiemy, gdy inny mózg byłby trafniejszy.",
    reassure_lang_title: "Wszystkie trzy biegłe",
    reassure_lang_desc: "Włoski, angielski i polski — ta sama jakość we wszystkich modelach.",
  },
  team: {
    nav_label: "Zespół",
    title: "Zespół",
    pretitle: "Magic Inbox",
    members_count: "członków",
    upsell_pretitle: "Workspace zespołu · Plan Business",
    upsell_title: "Wprowadź swój zespół do NEURACOM.",
    upsell_subtitle: "Magic Inbox jest częścią planu Business.",
    upsell_card_title: "Magic Inbox — wspólny workspace zespołu",
    upsell_card_desc: "Zaproś do 5 kolegów, zobacz nad czym pracują i uczyń NEURACOM warstwą AI Twojego zespołu.",
    upsell_feat_1: "Do 5 miejsc — zaproszenia mailowe",
    upsell_feat_2: "Wspólny feed aktywności całego zespołu",
    upsell_feat_3: "Jedna subskrypcja Business obejmuje wszystkich",
    upsell_cta: "Przejdź na Business",
    create_title: "Utwórz zespół",
    create_subtitle: "Jesteś na Business — skonfiguruj zespół w 10 sekund.",
    field_name: "Nazwa zespołu",
    field_name_placeholder: "Acme Marketing",
    create_btn: "Utwórz zespół",
    created: "Zespół utworzony.",
    create_failed: "Nie udało się utworzyć zespołu. Spróbuj ponownie.",
    members_title: "Członkowie i zaproszenia",
    invite_placeholder: "kolega@firma.com",
    invite_btn: "Zaproś",
    invited: "Zaproszenie wysłane.",
    invite_failed: "Nie udało się wysłać zaproszenia.",
    invite_pending: "Zaproszenie oczekuje",
    invite_revoked: "Zaproszenie cofnięte.",
    role_owner: "Właściciel",
    role_member: "Członek",
    remove_confirm: "Usunąć tego członka z zespołu?",
    removed: "Członek usunięty.",
    leave_btn: "Opuść zespół",
    leave_confirm: "Czy na pewno chcesz opuścić zespół?",
    left: "Opuściłeś zespół.",
    delete_btn: "Usuń zespół",
    delete_confirm: "Trwale usunąć ten zespół? Wszyscy członkowie stracą dostęp.",
    deleted: "Zespół usunięty.",
    danger_title: "Strefa niebezpieczna",
    danger_desc: "Usunięcie zespołu odpina wszystkich członków. Nie usuwa ich kont ani treści.",
    full: "Zespół jest pełny. Usuń kogoś przed wysłaniem kolejnego zaproszenia.",
    feed_title: "Aktywność zespołu",
    feed_desc: "Live feed ważnych wydarzeń wszystkich członków.",
    feed_empty: "Brak aktywności zespołu. Pojawi się tutaj, gdy członkowie zaczną używać NEURACOM.",
    accept_loading: "Dołączanie do zespołu…",
    accept_success_title: "Jesteś w zespole!",
    accept_success_desc: "Witaj w zespole {name}.",
    accept_continue: "Otwórz workspace zespołu",
    accept_error_title: "Nie udało się przyjąć zaproszenia",
    accept_error_generic: "To zaproszenie jest nieprawidłowe lub wygasło.",
    accept_go_dashboard: "Przejdź do panelu",
    err_TEAM_INVITE_INVALID: "Ten link zaproszenia jest nieprawidłowy lub został cofnięty.",
    err_TEAM_INVITE_EXPIRED: "Zaproszenie wygasło. Poproś właściciela o nowe.",
    err_TEAM_INVITE_EMAIL_MISMATCH: "To zaproszenie dotyczy innego adresu e-mail.",
    err_TEAM_ALREADY_MEMBER: "Jesteś już w zespole.",
    err_TEAM_LIMIT_REACHED: "Zespół osiągnął limit członków.",
    err_TEAM_REQUIRES_BUSINESS: "Przejdź na plan Business, aby utworzyć zespół.",
    err_TEAM_INVITE_SELF: "Nie możesz zaprosić samego siebie.",
    err_TEAM_INVITE_DUPLICATE: "Dla tego adresu istnieje już oczekujące zaproszenie.",
    err_TEAM_INVITE_ALREADY_IN_TEAM: "Ten użytkownik jest już w zespole.",
    err_TEAM_NOT_OWNER: "Tylko właściciel zespołu może to zrobić.",
    err_TEAM_OWNER_CANNOT_LEAVE: "Właściciele nie mogą opuścić — usuń zespół zamiast tego.",
  },
  images: {
    title: "Studio obrazów",
    prompt_label: "Opisz obraz, który chcesz stworzyć",
    prompt_label_edit: "Opisz, jak przekształcić obraz referencyjny",
    prompt_placeholder: "Futurystyczna panorama miasta o zachodzie słońca, kinowe oświetlenie...",
    prompt_placeholder_edit: "Zmień w akwarelę / umieść na Marsie / dodaj neony…",
    provider_label: "Dostawca",
    provider_gemini: "Gemini Nano Banana",
    provider_openai: "OpenAI GPT-Image-1",
    generate_btn: "Wygeneruj obraz",
    edit_btn: "Edytuj z referencją",
    edit_badge: "Edycja",
    edit_success: "Obraz zedytowany",
    gen_success: "Obraz wygenerowany",
    generating: "Generowanie… może to potrwać do 60 sekund.",
    gallery: "Twoja galeria",
    no_images: "Brak obrazów. Wygeneruj pierwszy powyżej.",
    download: "Pobierz",
    reference_label: "Obraz referencyjny (opcjonalnie, dla image-to-image)",
    reference_pick: "Kliknij, aby przesłać PNG / JPG / WEBP",
    reference_size_hint: "Maks. 8 MB",
    reference_active: "Referencja aktywna",
    reference_hint: "Następna generacja przekształci ten obraz na podstawie Twojego promptu.",
    reference_forced_gemini: "Obrazy referencyjne obsługuje tylko Gemini Nano Banana. Przełączono dostawcę.",
    no_reference_support: "Brak referencji",
    err_QUOTA_IMAGES_EXCEEDED: "Osiągnięto miesięczny limit obrazów. Zaktualizuj plan.",
    err_IMAGE_PROVIDER_ERROR: "Błąd dostawcy obrazów. Spróbuj drugiego.",
    err_IMAGE_REFERENCE_INVALID_BASE64: "Nie można odczytać obrazu referencyjnego. Spróbuj innego pliku.",
    err_IMAGE_REFERENCE_TOO_LARGE: "Obraz referencyjny jest za duży (maks. 8 MB).",
    err_REFERENCE_INVALID_TYPE: "Nieobsługiwany typ pliku — użyj PNG, JPG lub WEBP.",
  },
  code: {
    title: "AI Code Builder",
    subtitle: "Opisz aplikację internetową lub stronę. Otrzymaj kompletny plik HTML.",
    subtitle_multi: "Opisz aplikację. Otrzymaj kompletny projekt wieloplikowy — podgląd, edycja, pobranie jako ZIP.",
    prompt_label: "Co budujemy?",
    prompt_placeholder: "Strona docelowa dla kawiarni z menu, galerią i formularzem kontaktowym…",
    generate_btn: "Generuj projekt",
    generating: "Budowanie… może to potrwać 30-90 sekund.",
    preview: "Podgląd",
    code: "Kod",
    download_html: "Pobierz .html",
    download_file: "Pobierz plik",
    download_zip: "Pobierz ZIP",
    copy_code: "Kopiuj kod",
    copy_file: "Kopiuj plik",
    copied: "Skopiowano!",
    files_label: "{count} plików",
    no_files: "Brak plików w tym projekcie.",
    projects: "Twoje projekty",
    no_projects: "Brak projektów. Opisz pierwszy pomysł powyżej.",
    generated_success: "Projekt wygenerowany",
    err_QUOTA_CODE_EXCEEDED: "Osiągnięto miesięczny limit generacji code. Zaktualizuj plan.",
    err_CODE_GEN_EMPTY: "Model nie zwrócił prawidłowego kodu. Spróbuj inaczej sformułować.",
  },
  billing: {
    title: "Płatności i subskrypcja",
    current_plan: "Bieżący plan",
    renewal: "Odnawia się",
    no_renewal: "Brak aktywnej subskrypcji",
    change_plan: "Zmień plan",
    history: "Historia płatności",
    no_history: "Brak transakcji.",
    paid: "Opłacone",
    pending: "Oczekuje",
    failed: "Nieudane",
  },
  payment: {
    processing: "Przetwarzanie płatności…",
    success_title: "Płatność udana!",
    success_subtitle: "Twoja subskrypcja jest aktywna.",
    go_dashboard: "Przejdź do panelu",
    cancelled_title: "Płatność anulowana",
    cancelled_subtitle: "Nie pobrano środków.",
    back_pricing: "Wróć do cennika",
  },
  footer: {
    tagline: "Platforma AI powered by TelcaVoIP",
    product: "Produkt",
    legal: "Prawne",
    terms: "Regulamin",
    privacy: "Prywatność",
    cookies: "Cookies",
    privacy_center: "Centrum Prywatności",
    contact_us: "Kontakt",
    contact: "Kontakt",
    copyright: "© 2026 TelcaVoIP International EU — Wszelkie prawa zastrzeżone",
  },
  documents: {
    title: "Dokumenty",
    subtitle: "Wgraj PDF i rozmawiaj z nim. Zadawaj pytania, otrzymuj streszczenia — powered by Claude.",
    upload_btn: "Wgraj PDF",
    upload_hint: "Upuść PDF tutaj lub kliknij, aby przeglądać (max 10 MB)",
    uploading: "Wgrywanie i ekstrakcja tekstu…",
    list_title: "Twoje dokumenty",
    no_documents: "Brak dokumentów. Wgraj pierwszy PDF powyżej.",
    pages: "stron",
    chars: "znaków",
    ask_placeholder: "Zapytaj o coś z tego dokumentu…",
    thinking: "Czytam dokument…",
    open: "Otwórz",
    err_DOC_INVALID_FORMAT: "Obsługiwane są tylko pliki PDF.",
    err_DOC_TOO_LARGE: "Plik zbyt duży (max 10 MB).",
    err_DOC_PARSE_ERROR: "Nie można odczytać tego PDF.",
    err_DOC_NO_TEXT_EXTRACTED: "Ten PDF nie zawiera zaznaczalnego tekstu (zeskanowany obraz?).",
    err_QUOTA_DOCUMENTS_EXCEEDED: "Miesięczny limit dokumentów osiągnięty. Zaktualizuj plan.",
    err_QUOTA_MESSAGES_EXCEEDED: "Miesięczny limit wiadomości osiągnięty. Zaktualizuj plan.",
    truncated_warning: "⚠️ Ten dokument jest duży ({chars} znaków). Tylko pierwsze 50 000 znaków jest używanych do odpowiedzi. Rozważ podzielenie PDF na mniejsze pliki, aby uzyskać pełne pokrycie.",
    legal_mode_on: "Tryb prawny WŁ",
    legal_mode_off: "Analiza prawna",
    legal_mode_on_hint: "Aktywna analiza klauzula-po-klauzuli",
    legal_mode_off_hint: "Kliknij, aby włączyć analizę klauzula-po-klauzuli (prawo IT/UE)",
    legal_mode_banner: "Tryb prawny aktywny: ten dokument będzie analizowany klauzula-po-klauzuli, z cytowaniem konkretnych artykułów Codice Civile, Codice del Consumo i RODO, sygnalizując klauzule abuzywne (art. 1341/1342 c.c., art. 33 Codice del Consumo).",
  },
  referrals: {
    title: "Zapraszaj kolegów, zarabiaj cash",
    subtitle: "Udostępnij swój link. Gdy kolega zasubskrybuje Legal Pro lub Business, otrzymasz €20 + 1 darmowy miesiąc Pro + 5% prowizji od każdego sprzedanego przez niego szablonu w marketplace przez kolejne 12 miesięcy.",
    your_code: "Twój kod",
    your_link: "Twój link polecający",
    copy: "Kopiuj",
    copied: "Skopiowano!",
    stats_invited: "Zaproszeni",
    stats_paying: "Nagrodzeni",
    stats_bonus: "Zdobyte miesiące bonusowe",
    stats_credit_balance: "Dostępne saldo",
    stats_credit_lifetime: "Łącznie zarobione",
    program_title: "Jak działa NEURACOM Affiliate",
    program_step1: "Udostępnij unikalny link kolegom",
    program_step2: "Zapisują się na Legal Pro lub Business",
    program_step3: "Zarabiasz €{credit} + 1 darmowy miesiąc Pro",
    program_step4: "Plus 5% prowizji od ich sprzedaży w marketplace przez 12 miesięcy",
    payout_hint: "Środki spływają do wypłaty z marketplace (próg €50). Idź do {sales}, aby wypłacić.",
    payout_hint_link: "Moja sprzedaż",
    commissions_title: "Ostatnie prowizje od zaproszonych kolegów",
    commissions_empty: "Brak prowizji. Gdy zaproszony kolega sprzeda szablon w marketplace, Twoje 5% pojawi się tutaj.",
    commissions_col_buyer: "Kupujący",
    commissions_col_price: "Cena sprzedaży",
    commissions_col_commission: "Twoje 5%",
    commissions_col_date: "Data",
    table_title: "Osoby, które zaprosiłeś",
    no_invites: "Brak zaproszeń. Udostępnij swój link, aby zacząć.",
    col_user: "Użytkownik",
    col_tier: "Plan",
    col_status: "Status",
    col_date: "Dołączył",
    col_eligible: "Okno prowizji",
    status_rewarded: "Nagrodzony",
    status_pending: "Oczekuje płatnej sub.",
    until: "do {date}",
    err_REF_INVALID_CODE: "Nieprawidłowy kod polecający.",
    err_REF_SELF_REFERRAL: "Nie możesz polecić siebie.",
    err_REF_ALREADY_REFERRED: "Masz już osobę polecającą.",
    err_REF_NOT_ELIGIBLE_PAID_USER: "Tylko użytkownicy Free mogą zastosować kod polecający.",
  },
  billing_v2: {
    cancel_subscription: "Anuluj subskrypcję",
    reactivate: "Reaktywuj subskrypcję",
    confirm_cancel: "Na pewno? Zachowasz dostęp do końca okresu, potem przejdziesz na Free.",
    cancelling_banner: "Twoja subskrypcja kończy się {date}. Możesz reaktywować w dowolnym momencie wcześniej.",
    expiring_soon: "Twoja subskrypcja odnawia się {date}. Odnów ręcznie wcześniej, aby zachować plan.",
    manual_renewal_note: "ℹ️ Obecnie subskrypcje są miesięczne, płacone ręcznie. Powiadomimy Cię przed wygaśnięciem.",
  },
  legal: {
    terms_title: "Regulamin",
    terms_intro: "Ten regulamin reguluje korzystanie z NEURACOM by TelcaVoIP. Przeczytaj uważnie.",
    terms_last_updated: "Ostatnia aktualizacja: Luty 2026",
    privacy_title: "Polityka prywatności",
    privacy_intro: "Szanujemy Twoją prywatność. Ta strona wyjaśnia, jakie dane zbieramy i jak ich używamy.",
    privacy_last_updated: "Ostatnia aktualizacja: Luty 2026",
    back_home: "← Powrót do strony głównej",
  },
  cookies: {
    banner_aria: "Zgoda na cookies",
    banner_title: "Szanujemy Twoją prywatność.",
    banner_text: "Używamy tylko niezbędnych plików cookie do utrzymania sesji i zapamiętania preferencji. Bez śledzenia, bez reklam.",
    banner_learn_more: "Dowiedz się więcej",
    accept_all: "OK, rozumiem",
    reject_all: "Tylko niezbędne",
    pill_label: "Cookies",
    pill_aria: "Otwórz preferencje cookies",
  },
  privacy_center: {
    pretitle: "RODO · Prawa Prywatności",
    title: "Centrum Prywatności",
    subtitle: "Jedno miejsce do wykonywania praw ochrony danych — niezależnie od tego, czy jesteś obecnym, byłym czy potencjalnym użytkownikiem. Odpowiadamy w ciągu 30 dni, zgodnie z art. 12 RODO.",
    dpo_title: "Inspektor Ochrony Danych (IOD)",
    dpo_desc: "Bezpośredni kontakt w sprawach prywatności, próśb lub zgłoszeń.",
    controller_title: "Administrator danych",
    controller_desc: "Podmiot prawny odpowiedzialny za przetwarzanie Twoich danych osobowych.",
    docs_title: "Dokumenty prawne",
    link_privacy: "Polityka prywatności",
    link_cookies: "Polityka cookie",
    link_terms: "Regulamin",
    form_title: "Wyślij wniosek dotyczący danych",
    form_desc: "Użyj tego formularza, jeśli nie masz (lub nie masz już) konta. Zarejestrowani użytkownicy mogą korzystać z tych praw bezpośrednio z Ustawień.",
    field_email: "Twój e-mail",
    field_type: "Rodzaj wniosku",
    field_message: "Wiadomość",
    field_message_placeholder: "Opisz swój wniosek. Dołącz kontekst, który pomoże nam zidentyfikować Twoje dane (np. dawny e-mail, przybliżona data rejestracji).",
    type_access: "Dostęp do danych (art. 15)",
    type_portability: "Przenoszenie danych (art. 20)",
    type_rectification: "Sprostowanie (art. 16)",
    type_erasure: "Usunięcie / prawo do bycia zapomnianym (art. 17)",
    type_objection: "Sprzeciw wobec przetwarzania (art. 21)",
    type_other: "Inne / zapytanie ogólne",
    deadline_note: "Odpowiadamy w ciągu 30 dni (art. 12 RODO).",
    submit_btn: "Wyślij wniosek",
    submit_success: "Wniosek otrzymany.",
    submit_failed: "Nie udało się wysłać. Spróbuj ponownie lub napisz na privacy@telcavoip.eu.",
    success_title: "Wniosek otrzymany",
    success_desc: "Dziękujemy. Powiadomiliśmy naszego IOD i otrzymasz odpowiedź w ciągu 30 dni. Sprawy pilne kieruj na privacy@telcavoip.eu.",
    authorities_title: "Organy nadzorcze",
    authorities_desc: "Jeśli uważasz, że Twoje prawa zostały naruszone, możesz złożyć skargę do organu ochrony danych w kraju swojego pobytu lub pracy.",
  },
  settings: {
    title: "Ustawienia",
    pretitle: "Konto",
    subtitle: "Zarządzaj profilem, prywatnością i prawami RODO.",
    profile_title: "Profil",
    profile_desc: "Szczegóły Twojego konta.",
    email: "E-mail",
    name: "Imię",
    plan: "Plan",
    locale: "Język",
    cookies_title: "Preferencje cookies",
    cookies_desc: "Przejrzyj lub zresetuj zgodę na cookies inne niż niezbędne.",
    cookies_reset_btn: "Resetuj zgodę cookies",
    cookies_reset_success: "Zgoda cookies wyczyszczona. Banner pojawi się ponownie.",
    export_title: "Pobierz swoje dane",
    export_desc: "Art. 20 RODO — pobierz pełny eksport JSON wszystkich danych osobowych, które przechowujemy.",
    export_btn: "Eksportuj moje dane (JSON)",
    export_success: "Eksport pobrany.",
    export_failed: "Nie udało się wygenerować eksportu. Spróbuj ponownie.",
    rights_title: "Twoje prawa RODO",
    rights_desc: "Zgodnie z rozporządzeniem UE 2016/679 masz następujące prawa, do wykonania w dowolnym momencie:",
    right_access: "Prawo dostępu (art. 15)",
    right_portability: "Prawo do przenoszenia danych (art. 20)",
    right_erasure: "Prawo do bycia zapomnianym (art. 17)",
    right_rectification: "Prawo do sprostowania (art. 16)",
    right_object: "Prawo sprzeciwu i ograniczenia (art. 21-22)",
    edit_profile_btn: "Edytuj profil",
    edit_title: "Edytuj profil",
    edit_desc: "Zaktualizuj imię lub zmień hasło. E-mail jest zablokowany — skontaktuj się z pomocą, aby go zmienić.",
    change_password: "Zmień hasło",
    change_password_hint: "Pozostaw puste, jeśli nie chcesz zmieniać hasła.",
    current_password: "Aktualne hasło",
    new_password: "Nowe hasło (min. 8 znaków)",
    edit_save_btn: "Zapisz zmiany",
    edit_success: "Profil zaktualizowany.",
    edit_failed: "Nie udało się zaktualizować profilu. Spróbuj ponownie.",
    edit_invalid_password: "Aktualne hasło jest nieprawidłowe.",
    edit_password_too_short: "Nowe hasło musi mieć co najmniej 8 znaków.",
    edit_current_password_required: "Wprowadź aktualne hasło, aby ustawić nowe.",
    edit_nothing_to_update: "Zmień coś przed zapisaniem.",
    danger_title: "Usuń konto",
    danger_desc: "Nieodwracalnie usuwa konto, czaty, obrazy, projekty code, dokumenty, prowizje partnerskie i zdarzenia aktywności. Rekordy płatności są pseudonimizowane, ale zachowane do celów księgowych.",
    delete_btn: "Usuń moje konto",
    delete_confirm_title: "Potwierdź usunięcie konta",
    delete_confirm_desc: "Aby potwierdzić, wpisz swój adres e-mail ({email}) poniżej. Tej akcji nie można cofnąć.",
    delete_confirm_btn: "Usuń trwale",
    delete_email_mismatch: "E-mail nie pasuje.",
    delete_success: "Konto usunięte. Przykro nam, że odchodzisz.",
    delete_failed: "Nie udało się usunąć konta. Skontaktuj się z pomocą.",
  },
  affiliate_page: {
    hero_pretitle: "Program Partnerski",
    hero_title: "Odsprzedawaj NEURACOM. Zarabiaj 20% co miesiąc.",
    hero_subtitle: "Pomóż firmom wdrożyć AI i zarabiaj 20% prowizji od każdej subskrypcji — tak długo, jak klient zostaje.",
    cta_apply: "Zgłoś się jako partner",
    cta_dashboard: "Otwórz panel partnera",
    benefit_commission_title: "20% prowizji co miesiąc",
    benefit_commission_desc: "Otrzymuj 20% od każdej płatnej subskrypcji, którą polecisz (Starter, Pro, Business). Wypłaty miesięczne, bez limitów.",
    benefit_tools_title: "Zestaw marketingowy",
    benefit_tools_desc: "Markowy link, panel ze statystykami i szablony e-maili, aby zamykać sprzedaż szybciej.",
    benefit_priority_title: "Priorytetowe wsparcie",
    benefit_priority_desc: "Bezpośredni kontakt z naszym zespołem. Pomagamy wdrożyć pierwszych klientów.",
    how_title: "Jak to działa",
    how_step1_title: "1. Zgłoś się",
    how_step1_desc: "Wyślij zgłoszenie. Rozpatrujemy w ciągu 48h.",
    how_step2_title: "2. Udostępnij link",
    how_step2_desc: "Po zatwierdzeniu udostępnij swój unikalny link leadom.",
    how_step3_title: "3. Zarabiaj",
    how_step3_desc: "20% prowizji od każdej płatnej subskrypcji. Wypłata na żądanie.",
    form_title: "Zostań partnerem NEURACOM",
    form_company: "Nazwa firmy (opcjonalnie)",
    form_website: "Strona www (opcjonalnie)",
    form_volume: "Przewidywane miesięczne polecenia",
    form_pitch: "Opowiedz nam o swojej publiczności",
    form_submit: "Wyślij zgłoszenie",
    status_pending_title: "Zgłoszenie oczekuje",
    status_pending_desc: "Dzięki! Nasz zespół rozpatrzy w ciągu 48 godzin. Otrzymasz e-mail po zatwierdzeniu.",
    status_approved_title: "Jesteś partnerem!",
    status_approved_desc: "Otwórz panel, weź swój link i zacznij zarabiać.",
    status_rejected_title: "Zgłoszenie odrzucone",
    status_rejected_desc: "Niestety nie możemy zatwierdzić zgłoszenia w tym momencie. Skontaktuj się z nami po szczegóły.",
    err_AFFILIATE_ALREADY_APPLIED: "Już złożyłeś zgłoszenie lub jesteś partnerem.",
    application_submitted: "Zgłoszenie wysłane!",
  },
  legal_kb: {
    title: "Osobista Baza Wiedzy Prawnej",
    title_nav: "Baza Prawna",
    pretitle: "Legal Pro · Prywatna baza",
    subtitle: "{count} prywatnych notatek — przypinaj orzeczenia, zapisuj odpowiedzi AI, gromadź własną wiedzę prawniczą. Wszystko w Twoim koncie.",
    new_note: "Nowa notatka",
    new_title: "Nowa notatka",
    edit_title: "Edytuj notatkę",
    search_placeholder: "Szukaj w tytule, treści, cytacie…",
    search_btn: "Szukaj",
    filter_by_tag: "Filtruj po tagach",
    clear_tag: "Wyczyść tag",
    empty_title: "Twoja Baza Wiedzy jest pusta",
    empty_desc: "Zapisuj orzeczenia, kopiuj odpowiedzi z czatu lub pisz własne notatki. Wszystko prywatne, dostępne tylko dla Ciebie.",
    source_all: "Wszystkie",
    source_jurisprudence: "Orzeczenia",
    source_chat: "Czat",
    source_document: "Dokumenty",
    source_manual: "Ręczne",
    pin: "Przypnij",
    unpin: "Odepnij",
    edit: "Edytuj",
    delete: "Usuń",
    confirm_delete: "Usunąć tę notatkę? Tej akcji nie można cofnąć.",
    toast_created: "Notatka zapisana w Bazie Wiedzy",
    toast_updated: "Notatka zaktualizowana",
    toast_deleted: "Notatka usunięta",
    err_load: "Nie udało się wczytać notatek",
    err_save: "Nie udało się zapisać notatki",
    err_delete: "Nie udało się usunąć notatki",
    err_required: "Tytuł i treść są wymagane",
    err_LEGAL_KB_TIER_REQUIRED: "Osobista Baza Wiedzy jest dostępna w planach Legal Pro i Business.",
    err_LEGAL_KB_NOTE_NOT_FOUND: "Ta notatka już nie istnieje.",
    field_title: "Tytuł",
    field_title_ph: "np. Klauzule abuzywne w umowach B2C",
    field_citation: "Cytat (opcjonalnie)",
    field_citation_ph: "np. Cass. civ. Sez. III n. 8268/2008",
    field_body: "Treść",
    field_body_ph: "Napisz notatkę, wklej odpowiedź AI lub opisz zasadę prawną…",
    field_tags: "Tagi",
    field_tags_ph: "umowy, B2C, rodo",
    field_tags_hint: "Oddzielone przecinkami. Maks. 20 tagów.",
    save_changes: "Zapisz zmiany",
    save_note: "Zapisz notatkę",
    disclaimer: "Notatki są prywatne dla Twojego konta NEURACOM. NIE zastępują porady prawnika — weryfikuj cytaty w oficjalnych źródłach (Italgiure, De Jure, EUR-Lex).",
    upsell_title: "Dostępne w Legal Pro i Business",
    upsell_body: "Zbuduj własną prywatną bazę wiedzy prawnej w NEURACOM. Zapisuj orzeczenia, odpowiedzi AI i notatki — wszystko z wyszukiwaniem, tagami i szyfrowane w spoczynku.",
    upsell_bullet1: "Zapisuj dowolne orzeczenie jednym kliknięciem",
    upsell_bullet2: "Zapisuj odpowiedzi AI jako wielokrotnego użytku zasady",
    upsell_bullet3: "Tagi, wyszukiwanie i przypinanie — Twoja baza rośnie z Tobą",
    upsell_cta: "Przejdź na Legal Pro",
    save_chat_btn: "Zapisz w Bazie",
    save_chat_title: "Zapisz odpowiedź AI",
    save_chat_hint: "Dodaj tytuł i cytat, a następnie zapisz tę odpowiedź w prywatnej Bazie Wiedzy.",
    use_in_chat: "Użyj w czacie",
    use_in_chat_added: "Notatka dodana jako kontekst następnego czatu",
    use_in_chat_already: "Ta notatka jest już w kontekście czatu",
    use_in_chat_max: "Maksymalnie {max} notatek na czat — usuń jedną najpierw",
  },
  fable5: {
    banner_title: "Powiadom mnie o Claude Fable 5",
    banner_body: "Bądź pierwszym, który dowie się, kiedy Fable 5 (1M kontekstu) będzie natywnie dostępny w NEURACOM Legal Pro. Wyślemy jedną wiadomość e-mail.",
    join_cta: "Powiadom mnie",
    leave: "Wypisz",
    subscribed: "Jesteś na liście oczekujących",
    toast_joined: "Otrzymasz powiadomienie, gdy Fable 5 będzie dostępny",
    toast_join_failed: "Zapis nieudany — spróbuj ponownie",
    toast_left: "Usunięto z listy oczekujących",
    toast_leave_failed: "Wypis nieudany — spróbuj ponownie",
  },
  comparison: {
    pretitle: "Porównanie · Dlaczego wertykalny prawny AI ma znaczenie",
    title: "Ogólny ChatGPT vs. NEURACOM Legal Pro",
    subtitle: "Ten sam miesięczny budżet, radykalnie różny rezultat. Szczegółowość cytatów i framework prywatności to obszary, w których prawnicy, IOD i księgowi tracą godziny tygodniowo z ogólnym AI.",
    col_feature: "Funkcjonalność",
    col_generic: "Ogólny AI",
    col_neuracom: "NEURACOM Legal Pro",
    generic_subtitle: "ChatGPT Plus / odp.",
    neuracom_subtitle: "Wertykalny AI prawny",
    cat_citations: "Cytaty i badanie orzecznictwa",
    cat_privacy: "Prywatność i zgodność",
    cat_workflow: "Workflow prawny",
    cat_cost: "Koszt i ROI",
    row_jurisprudence: "Baza 103 wybranych orzeczeń Cassazione + CGUE",
    row_kb: "Osobista Baza Wiedzy Prawnej (prywatna, szyfrowana)",
    row_auto_cite: "Auto-cytaty i sugestie ambient bazy podczas pisania",
    row_hallucinations: "Cytaty dosłowne, odporne na halucynacje",
    row_eu_hosted: "Infrastruktura hostowana w UE",
    row_gdpr: "100% GDPR-compliant by design",
    row_no_training: "Twoje dane nigdy nie trenują zewnętrznych modeli",
    row_templates: "7 włoskich szablonów prawnych (NDA, RODO, umowy…)",
    row_legal_register: "Formalny włoski rejestr prawny od razu",
    row_doc_analysis: "Analiza klauzula-po-klauzuli umów PDF",
    row_price: "Abonament miesięczny",
    row_value: "Czas zaoszczędzony na badaniu (~10h/mies.)",
    roi_headline: "Zwrot: ~3 dni/mies. przy stawce 60€/h.",
    roi_body: "Włoski adwokat solo przy stawce 60€/h oszczędza ~10h/mies. badań z NEURACOM Legal Pro. To 600€ odzyskanego czasu — za 149€/mies. Matematyka brutalna.",
  },
  atti: {
    title_nav: "Generator pism",
    pretitle: "Legal Pro · Funkcja killer",
    title: "Generuj kompletne pisma prawne w 60 sekund",
    subtitle: "Wybierz typ pisma, wypełnij 3 pola, otrzymaj kompletny włoski dokument prawny — formalny rejestr, ponumerowane sekcje, cytaty wstrzyknięte z Twojej osobistej Bazy przez Claude Opus 4.8.",
    sections_count: "sekcji",
    start: "Rozpocznij",
    back: "Wstecz",
    form_hint: "Wymagane sekcje: {sections}",
    field_parties: "Strony",
    field_parties_ph: "np. Mario Rossi (powód) vs ACME S.r.l. (pozwany)",
    field_subject: "Przedmiot / Materia",
    field_subject_ph: "np. Rozwiązanie umowy + odszkodowanie",
    field_facts: "Istotne fakty",
    field_facts_ph: "Opisz daty, kwoty, naruszenia, komunikację, poniesioną szkodę…",
    field_court: "Sąd / Organ (opcjonalnie)",
    field_court_ph: "np. Sąd Mediolanu — Sekcja Handlowa",
    field_context: "Dodatkowy kontekst (opcjonalnie)",
    field_context_ph: "wcześniejsze próby, uwagi strategiczne…",
    generate_cta: "Wygeneruj pismo",
    kb_hint: "Top-4 najtrafniejsze notatki z osobistej Bazy zostaną wstrzyknięte automatycznie.",
    generating_title: "Tworzę Twój dokument",
    generating_hint: "Claude Opus 4.8 pisze w formalnym włoskim rejestrze prawnym.",
    chars: "znaków",
    kb_used: "notatki Bazy użyte",
    copy: "Kopiuj",
    print: "Drukuj",
    save_to_kb: "Zapisz w Bazie",
    new_atto: "Nowe pismo",
    toast_generated: "Dokument gotowy — sprawdź i edytuj przed złożeniem",
    toast_copied: "Skopiowano do schowka",
    toast_saved_kb: "Zapisano w Bazie Wiedzy",
    err_required: "Strony, przedmiot i fakty są wymagane",
    err_generation: "Generowanie nieudane — spróbuj ponownie",
    err_copy: "Kopiowanie nieudane",
    err_save_kb: "Nie udało się zapisać w Bazie",
    tab_create: "Nowe pismo",
    tab_archive: "Moje pisma",
    archive_search_ph: "Szukaj po przedmiocie lub stronach…",
    archive_filter_all: "Wszystkie typy",
    archive_empty_title: "Brak pism",
    archive_empty_body: "Każde wygenerowane pismo jest tu automatycznie zapisywane. Zacznij od nowego — zajmie 60 sekund.",
    archive_empty_cta: "Wygeneruj pierwsze pismo",
    archive_view: "Otwórz",
    archive_delete: "Usuń",
    archive_delete_confirm: "Usunąć to pismo? Tej operacji nie można cofnąć.",
    archive_delete_success: "Pismo usunięte z archiwum",
    archive_open_back: "Wróć do moich pism",
    archive_count_one: "{count} pismo",
    archive_count_many: "{count} pism",
    archive_loading: "Wczytuję Twoje pisma…",
    archive_load_error: "Nie udało się wczytać Twoich pism",
    archive_filter_label: "Filtruj po typie",
    upsell_title: "Generator pism to część Legal Pro",
    upsell_body: "Generuj kompletne pisma prawne (memoriały, skargi, opinie, wezwania…) w formalnym włoskim rejestrze, z cytatami Auto-KB wstrzykniętymi przez Claude Opus 4.8. Dostępne w planach Legal Pro i Business.",
    upsell_cta: "Przejdź na Legal Pro",
  },
  partner: {
    title: "Panel Partnera",
    subtitle: "Śledź swoje prowizje i rozwijaj biznes.",
    your_link: "Twój link partnerski",
    copy: "Kopiuj",
    stat_pending: "Oczekujące",
    stat_ready: "Gotowe do wypłaty",
    stat_paid: "Wypłacone",
    stat_lifetime: "Razem",
    stat_count: "Prowizje",
    commissions_title: "Ostatnie prowizje",
    no_commissions: "Brak prowizji. Udostępnij link, aby zacząć zarabiać.",
    col_user: "Polecony użytkownik",
    col_plan: "Plan",
    col_amount: "Kwota",
    col_commission: "Prowizja",
    col_status: "Status",
    col_date: "Data",
    status_pending: "Oczekuje",
    status_ready_for_payout: "Gotowa",
    status_paid: "Wypłacona",
    request_payout: "Poproś o wypłatę",
    payout_requested: "Wypłata zażądana",
    link_copied: "Link skopiowany",
    open_kit: "Kit startowy",
    share: "Udostępnij",
  },
  partner_landing: {
    recommended_by: "Polecone przez",
    hero_pretitle: "Oferta wyłączna · Platforma AI",
    hero_title: "Wprowadź AI do swojej firmy — w każdym języku.",
    hero_subtitle_prefix: "Wybrane przez",
    hero_subtitle_suffix: ", NEURACOM daje Ci Claude, GPT i Gemini, generowanie obrazów AI, Q&A na dokumentach i code builder — wszystko w jednej europejskiej subskrypcji.",
    cta_primary: "Zacznij za darmo — bez karty",
    cta_secondary: "Zobacz cennik",
    trust_gdpr: "Zgodne z RODO",
    trust_eu: "Infrastruktura UE",
    trust_nocard: "Bez karty kredytowej",
    feat_chat: "Czat AI Multi-model",
    feat_image: "Generowanie Obrazów",
    feat_code: "AI Code Builder",
    feat_docs: "Q&A Dokumentów",
    results_title: "Wyniki prawdziwych zespołów",
    result1_label: "Czas pisania",
    result1_quote: "Skróciliśmy czas produkcji treści o 75% w całym zespole marketingu.",
    result2_label: "Współczynnik odpowiedzi",
    result2_quote: "Spersonalizowane e-maile sprzedażowe potroiły nasz wskaźnik odpowiedzi w pierwszym miesiącu.",
    result3_label: "Od pomysłu do landing page",
    result3_quote: "Opisałem nową ofertę po polsku i wypuściłem landing przed lunchem.",
    cta_title: "Zacznij za darmo dzisiaj.",
    cta_subtitle: "Aktualizuj tylko, gdy wypuścisz coś prawdziwego.",
    cta_button: "Załóż konto",
    cta_attribution: "Dostarczone przez",
    not_found_title: "Link partnera nie znaleziony",
    not_found_desc: "Ten link zaproszenia jest nieprawidłowy lub wygasł. Sprawdź adres URL u swojego partnera.",
    go_home: "Idź na stronę główną",
  },
  partner_kit: {
    back: "Powrót do panelu",
    title: "Kit startowy",
    subtitle: "Wszystko, czego potrzebujesz, aby pozyskać pierwszych klientów. Skopiuj, spersonalizuj, wyślij.",
    cobranded_label: "Twoja landing co-branded",
    cobranded_desc: "Wyślij ten link do leadów. Trafią na stronę z napisem \"Polecone przez Ciebie\" — wszystkie rejestracje są przypisane do Twojego konta.",
    preview: "Podgląd",
    tab_email: "E-mail",
    tab_social: "Social",
    tab_chat: "Czat / DM",
    subject_label: "Temat",
    copy: "Kopiuj",
    copied: "Skopiowano!",
    no_templates: "Brak szablonów.",
    email_cold_title: "Pierwszy kontakt",
    email_cold_subject: "Workspace AI, którego Twój zespół naprawdę użyje",
    email_cold_body: "Cześć {imie},\n\nKrótkie pytanie: nadal przełączasz się między ChatGPT, osobnym narzędziem do obrazów i Google Docs, żeby pracować z AI?\n\nZacząłem polecać NEURACOM — jeden europejski workspace z Claude, GPT i Gemini, generowaniem obrazów, Q&A dokumentów i AI code builderem. Polski, włoski, angielski od ręki, bez konfiguracji.\n\nMoi klienci oszczędzają godziny w pierwszych 5 dniach. Możesz zacząć za darmo, bez karty:\n\n{{LINK}}\n\nChętnie przeprowadzę Cię przez to w 15-minutowej rozmowie.\n\nPozdrawiam,\n{{PARTNER}}",
    email_followup_title: "Follow-up (brak odpowiedzi)",
    email_followup_subject: "Czy dotarł do Ciebie link NEURACOM?",
    email_followup_body: "Cześć {imie},\n\nPodbijam powyższy mail, gdyby się zgubił. NEURACOM to europejski workspace AI, o którym pisałem — czat multi-model, generowanie obrazów, Q&A dokumentów i code builder, wszystko w jednym miejscu.\n\nJeśli 5 minut na sprawdzenie \"czy naprawdę zastąpi 4 narzędzia\" brzmi sensownie — darmowe konto:\n\n{{LINK}}\n\nBez karty. Anuluj kiedy chcesz.\n\n{{PARTNER}}",
    email_value_title: "Pitch wartości (ciepły lead)",
    email_value_subject: "3 rzeczy, które NEURACOM robi, a samo ChatGPT nie",
    email_value_body: "Cześć {imie},\n\nJak obiecywałem, trzy rzeczy NEURACOMa, które zwracają koszt subskrypcji w pierwszym tygodniu:\n\n1. Zadawaj pytania PDF-om w naturalnym języku — umowy, instrukcje, faktury. Cytowane odpowiedzi, bez lania wody.\n2. Generuj idealny obraz do każdego posta bloga/social z Gemini Nano Banana lub GPT-Image-1, w tej samej aplikacji.\n3. Opisz aplikację lub landing page w swoim języku → otrzymaj działający HTML jednym kliknięciem.\n\nWszystko w jednej europejskiej subskrypcji, zgodne z RODO, trójjęzyczny interfejs (IT/EN/PL).\n\nZacznij za darmo tutaj:\n\n{{LINK}}\n\nDaj znać, jeśli chcesz live demo 1:1.\n\n{{PARTNER}}",
    social_linkedin_title: "Post LinkedIn",
    social_linkedin_body: "Większość zespołów, z którymi rozmawiam, używa 3-4 różnych narzędzi AI — i nadal kopiuje treści między nimi.\n\nOstatnio polecam swoim klientom NEURACOM, bo naprawdę rozwiązuje ten problem:\n\n→ Jeden workspace, trzy modele AI (Claude / GPT / Gemini)\n→ Generowanie obrazów, Q&A dokumentów i AI code builder wbudowane\n→ Infrastruktura UE, zgodne z RODO, trójjęzyczne (IT/EN/PL)\n→ Przejrzyste miesięczne ceny, bez niespodzianek z tokenami\n\nDarmowe testy, bez karty:\n{{LINK}}\n\n#AI #produktywność #UE",
    social_twitter_title: "Post Twitter / X",
    social_twitter_body: "Stop żonglowaniu 4 narzędziami AI.\n\nNEURACOM = Claude + GPT + Gemini + generowanie obrazów + Q&A dokumentów + code builder w jednym europejskim workspace.\n\nTrójjęzyczne UI. Zgodne z RODO. Darmowy start.\n\n{{LINK}}",
    social_facebook_title: "Post Facebook",
    social_facebook_body: "Jeśli Ty (lub Twój zespół) płacicie za ChatGPT, Midjourney i kilka innych subskrypcji AI, sprawdź NEURACOM. Jeden europejski workspace z Claude, GPT, Gemini, generowaniem obrazów, Q&A dokumentów i AI code builderem — polski, włoski, angielski od ręki.\n\nDarmowe testy, bez karty:\n{{LINK}}",
    chat_whatsapp_title: "WhatsApp / Telegram",
    chat_whatsapp_body: "Cześć 👋 krótko — używam NEURACOMa i to praktycznie Claude + GPT + Gemini + generowanie obrazów + Q&A dokumentów w jednej europejskiej apce. Darmowy plan, bez karty. Myślę, że pomoże Twojemu zespołowi:\n{{LINK}}",
    chat_dm_title: "DM LinkedIn / Slack",
    chat_dm_body: "Cześć {imie}, myślę, że NEURACOM oszczędzi Twojemu zespołowi mnóstwo przełączania kontekstu. Jeden europejski workspace dla Claude / GPT / Gemini + generowanie obrazów + Q&A dokumentów. Darmowy test (bez karty):\n{{LINK}}\nChętnie zrobię demo.",
  },
  activity: {
    pretitle: "Aktywność",
    title: "Twoja oś czasu",
    subtitle: "Wszystko, co dzieje się z Twoim kontem, w jednym miejscu. Te same powiadomienia wysyłamy mailem — tu masz szybszy podgląd.",
    mark_all_read: "Oznacz wszystko jako przeczytane",
    empty_title: "Brak wydarzeń",
    empty_desc: "Aktywność pojawi się tutaj w miarę korzystania z NEURACOM.",
    load_more: "Załaduj więcej",
    action_dashboard: "Otwórz panel",
    action_kit: "Otwórz Kit startowy",
    action_partner: "Panel partnera",
    action_upgrade: "Zobacz plany",
    event: {
      welcome: {
        title: "Witaj w NEURACOM",
        desc: "Twoje konto jest gotowe do użycia.",
      },
      subscription_activated: {
        title: "Subskrypcja aktywna",
        desc: "Plan {plan} · {amount} — 30 dni pełnego dostępu.",
      },
      partner_approved: {
        title: "Zgłoszenie partnera zatwierdzone",
        desc: "Jesteś zatwierdzonym partnerem. Czas udostępnić swój kit.",
      },
      commission_earned: {
        title: "Nowa prowizja",
        desc: "+{amount} z poleconej subskrypcji {plan}.",
      },
      payout_requested: {
        title: "Wypłata zażądana",
        desc: "{amount} w toku — {count} prowizji w kolejce.",
      },
      payout_paid: {
        title: "Wypłata zrealizowana",
        desc: "{amount} przelane na Twoje konto.",
      },
      quota_warning: {
        title: "Limit prawie wyczerpany",
        desc: "Wykorzystano {pct}% limitu {resource} w tym miesiącu.",
      },
    },
  },
  admin: {
    title: "Konsola Admin",
    subtitle: "Zarządzaj kodami promo, partnerami i prowizjami.",
    tab_stats: "Statystyki",
    tab_sources: "Źródła",
    tab_promos: "Kody promo",
    tab_affiliates: "Partnerzy",
    tab_commissions: "Prowizje",
    stat_users: "Wszyscy użytkownicy",
    stat_paid: "Płatni użytkownicy",
    stat_mrr: "MRR",
    stat_revenue: "Łączne przychody",
    stat_affiliates: "Zatwierdzeni partnerzy",
    stat_commissions: "Oczekujące prowizje",
    promos_title: "Kody promo",
    new_promo: "Nowy kod promo",
    table_code: "Kod",
    table_plan: "Plan",
    table_discount: "Cena promocyjna",
    table_max: "Maks. użyć",
    table_used: "Użyte",
    table_active: "Aktywny",
    table_actions: "Akcje",
    activate: "Aktywuj",
    deactivate: "Dezaktywuj",
    delete: "Usuń",
    create_promo_title: "Utwórz kod promo",
    f_code: "Kod (np. SUMMER25)",
    f_plan: "Plan",
    f_discount: "Cena promocyjna (€)",
    f_max_uses: "Maks. użyć (puste = bez limitu)",
    f_description: "Opis (opcjonalnie)",
    create: "Utwórz",
    affiliates_title: "Partnerzy",
    af_pending: "Oczekujące zgłoszenia",
    af_approved: "Zatwierdzeni partnerzy",
    approve: "Zatwierdź",
    reject: "Odrzuć",
    commissions_title: "Prowizje",
    mark_paid: "Oznacz jako wypłacone",
    no_data: "Brak danych.",
    tiers_breakdown: "Rozkład planów",
    col_date: "Data",
    col_affiliate: "Partner",
    col_referred: "Polecony",
    col_plan: "Plan",
    col_commission: "Prowizja",
    col_status: "Status",
    col_action: "Akcja",
    app_company: "Firma",
    app_web: "Web",
    app_volume: "Wolumen",
    app_per_month: "mies.",
    promo_created: "Promo utworzona",
    affiliate_approved: "Partner zatwierdzony",
    affiliate_rejected: "Partner odrzucony",
    marked_paid: "Oznaczone jako wypłacone",
    sources_total_signups: "Łączna liczba rejestracji",
    sources_total_paid: "Płatne rejestracje",
    sources_total_installs: "Instalacje PWA",
    sources_table_title: "Akwizycja według źródła",
    sources_table_desc: "Skąd pochodzą Twoi płatni klienci i instalacje PWA? Wykorzystaj te dane, aby inwestować w kanały, które konwertują.",
    sources_col_source: "Źródło",
    sources_col_signups: "Rejestracje",
    sources_col_paid: "Płatni",
    sources_col_installs: "Instalacje",
    sources_col_conv: "% Płatnych",
    sources_empty: "Brak danych o akwizycji. Źródła pojawią się tutaj, gdy użytkownicy zarejestrują się lub zainstalują PWA.",
    sources_legend: "QR landing = odwiedzający przez kod QR z landing page. Install banner = instalacja przez pływający prompt. Direct = bez parametru atrybucji.",
    tab_blog: "Blog",
    blog: {
      count_drafts: "Szkice",
      count_published: "Opublikowane",
      count_total: "Łącznie",
      gen_title: "Wygeneruj nowy artykuł z Claude",
      topic_label: "Temat",
      topic_ph: "Np. Jak działa nieważność z urzędu po wyroku Cass. SS.UU. 26242/2014",
      keyword_label: "Główne słowo kluczowe SEO",
      keyword_ph: "Np. nieważność umowy z urzędu",
      locale_label: "Język",
      ruling_optional: "Wyrok źródłowy (opcjonalnie)",
      ruling_headline: "Nagłówek / massima",
      ruling_court: "Sąd",
      ruling_number: "Numer wyroku",
      ruling_date: "Data (YYYY-MM-DD)",
      ruling_principle: "Zasada prawna",
      generate_btn: "Wygeneruj szkic (~30s)",
      generating: "Claude pisze…",
      gen_success: "Szkic gotowy. Sprawdź i opublikuj.",
      gen_error: "Generowanie nieudane. Spróbuj ponownie.",
      reviewing_draft: "Przegląd szkicu",
      editing_existing: "Edytuj artykuł",
      field_title: "Tytuł (SEO)",
      field_meta: "Meta opis",
      field_keyword: "Słowo kluczowe",
      field_tags: "Tagi (oddzielone przecinkami)",
      field_hero_url: "URL obrazu głównego (opcjonalnie)",
      field_body: "Treść artykułu (markdown)",
      save_draft_btn: "Zapisz jako szkic",
      save_publish_btn: "Zapisz i opublikuj",
      discard_btn: "Odrzuć",
      save_draft_success: "Szkic zapisany",
      save_publish_success: "Artykuł opublikowany!",
      save_error: "Zapisywanie nie powiodło się",
      view_live: "Artykuł jest online",
      open: "Otwórz",
      all_posts: "Wszystkie artykuły",
      no_posts: "Brak artykułów. Wygeneruj pierwszy powyżej.",
      published: "Opublikowany",
      unpublished: "Przywrócony do szkicu",
      deleted: "Artykuł usunięty",
      confirm_delete: "Trwale usunąć \"{title}\"?",
      action_error: "Akcja nieudana",
      err_topic_short: "Temat musi mieć co najmniej 5 znaków",
      err_missing_fields: "Wypełnij tytuł, meta opis i treść (min. 100 znaków)",
      scheduler_title: "Cotygodniowy auto-blog",
      scheduler_desc: "Każdego poniedziałku rano system wybiera wyrok z bazy Orzecznictwo, generuje szkic z Claude i wysyła Ci mail z linkiem do zatwierdzenia.",
      next_run: "Następny run",
      corpus_used: "Wykorzystany korpus",
      recipients: "Odbiorcy",
      last_run: "Ostatni run",
      run_now_btn: "Uruchom teraz",
      running_now: "Uruchamianie…",
      run_now_success: "Szkic utworzony z wyroku {ruling} i wysłany e-mailem.",
      run_now_error: "Uruchomienie nieudane",
      confirm_run_now: "Uruchomić teraz generowanie szkicu z następnego dostępnego wyroku? Zajmie to ~60 sekund.",
    },
  },
  marketplace: {
    nav: "Marketplace",
    pretitle: "PEER-TO-PEER",
    title: "Pierwszy włoski marketplace szablonów prawniczych.",
    subtitle: "Publikuj zanonimizowane wersje swoich najlepszych pism. Zarabiaj za każdym razem, gdy kolega je kupi.",
    cta_browse: "Przeglądaj szablony",
    cta_publish: "Opublikuj z mojego archiwum",
    public_browse_anyone: "Przeglądanie jest darmowe dla każdego. Zakup wymaga Legal Pro lub Business.",
    search_ph: "Szukaj szablonów po tytule, tagu lub temacie…",
    filter_all_types: "Wszystkie typy",
    sort_recent: "Najnowsze",
    sort_popular: "Najpopularniejsze",
    sort_price_asc: "Cena: rosnąco",
    sort_price_desc: "Cena: malejąco",
    empty_title: "Brak szablonów",
    empty_body: "Bądź pierwszym wydawcą — Twoje archiwum jest gotowe, a prowizja to tylko 15%.",
    card_by: "od",
    card_purchases: "{count} sprzedanych",
    card_buy_cta: "Zobacz szczegóły",
    price_from: "Od",
    detail_purchases: "Sprzedaży",
    detail_anon_badge: "Zanonimizowany przez AI i sprawdzony przez autora",
    detail_buy_cta: "Kup za €{price}",
    detail_buy_locked_cta: "Przejdź na Legal Pro, aby kupić",
    detail_owns_it: "Masz już ten szablon",
    detail_open_doc: "Otwórz pełny dokument",
    detail_is_author: "Jesteś autorem tego szablonu",
    detail_back: "Wróć do marketplace'u",
    detail_preview_label: "Podgląd (pierwszy akapit)",
    detail_locked_hint: "Pełny dokument zostanie odblokowany po zakupie.",
    publish_modal_title: "Opublikuj w marketplace",
    publish_step_anonymize: "1. Anonimizuj",
    publish_step_review: "2. Przejrzyj i edytuj",
    publish_step_meta: "3. Tytuł, cena i tagi",
    publish_step_publish: "4. Publikuj",
    publish_anonymize_intro: "Claude usunie każde imię, adres, kod podatkowy, datę i kwotę. Struktura prawna i cytaty pozostaną nietknięte.",
    publish_anonymize_cta: "Anonimizuj z AI",
    publish_anonymize_running: "Anonimizacja w toku… (~20s)",
    publish_anonymized_label: "Tekst zanonimizowany (edytowalny)",
    publish_original_label: "Oryginał (referencyjnie)",
    publish_title_label: "Tytuł publiczny *",
    publish_title_ph: "Np. Pismo procesowe — klauzula abuzywna w umowie konsumenckiej",
    publish_desc_label: "Opis *",
    publish_desc_ph: "Wyjaśnij kontekst prawny, dla kogo to jest i co zawiera…",
    publish_tags_label: "Tagi (oddzielone przecinkiem, maks. 10)",
    publish_tags_ph: "konsument, klauzule abuzywne, art. 1341",
    publish_category_label: "Kategoria",
    publish_category_ph: "cywilne, pracy, podatkowe…",
    publish_price_label: "Cena *",
    publish_price_hint: "NEURACOM pobiera 15%. Zarabiasz €{author_share} z każdej sprzedaży.",
    publish_save_draft: "Zapisz wersję roboczą",
    publish_publish: "Opublikuj teraz",
    publish_remove: "Usuń z marketplace'u",
    publish_drafts_title: "Wersje robocze i opublikowane",
    publish_status_draft: "Wersja robocza",
    publish_status_published: "Live",
    publish_status_removed: "Usunięty",
    publish_open_archive_cta: "Wybierz pismo ze swojego archiwum",
    publish_empty_archive_cta: "Wygeneruj pierwsze pismo",
    toast_anonymized: "Anonimizacja AI gotowa — sprawdź i edytuj w razie potrzeby",
    toast_template_created: "Szablon zapisany jako wersja robocza",
    toast_template_updated: "Szablon zaktualizowany",
    toast_template_published: "Szablon jest teraz live w marketplace",
    toast_template_removed: "Szablon usunięty",
    err_anonymize: "Anonimizacja nie powiodła się — spróbuj ponownie",
    err_create: "Nie udało się utworzyć szablonu",
    err_publish: "Nie udało się opublikować szablonu",
    err_invalid_price: "Niedozwolony poziom cenowy",
    sales_title: "Moja sprzedaż",
    sales_balance_label: "Dostępne saldo",
    sales_lifetime_label: "Łączne przychody",
    sales_sales_label: "Sprzedaży",
    sales_paid_out_label: "Wypłacono",
    sales_payout_threshold: "Próg wypłaty: €{threshold}",
    sales_payout_cta: "Poproś o wypłatę",
    sales_payout_below: "Osiągnij €{threshold}, aby poprosić o wypłatę.",
    sales_payout_pending: "Wniosek o wypłatę już oczekuje",
    sales_payout_modal_title: "Poproś o wypłatę",
    sales_payout_iban_label: "IBAN",
    sales_payout_iban_ph: "PL61 1090 1014 0000 0712 1981 2874",
    sales_payout_notes_label: "Notatki dla zespołu NEURACOM (opcjonalnie)",
    sales_payout_submit: "Potwierdź wniosek o wypłatę",
    sales_payout_success: "Wypłata zlecona. NEURACOM przetworzy w ciągu 3 dni roboczych.",
    sales_recent_title: "Ostatnia sprzedaż",
    sales_payouts_title: "Historia wypłat",
    sales_no_sales: "Brak sprzedaży — opublikuj szablon, aby zacząć zarabiać.",
    library_title: "Moje zakupione szablony",
    library_empty: "Brak zakupów. Przeglądaj marketplace, aby znaleźć szablony pasujące do Twojej praktyki.",
    library_open: "Otwórz",
    success_title: "Zakup zakończony!",
    success_body: "Szablon jest odblokowany w Twojej bibliotece.",
    success_cta_library: "Otwórz moją bibliotekę",
    success_cta_marketplace: "Wróć do marketplace'u",
    success_polling: "Potwierdzam płatność…",
    upgrade_cta_buy: "Zostań Legal Pro, aby kupować szablony",
  },
  publish_from_atti: {
    button: "Opublikuj w marketplace",
    helper: "Zarabiaj za każdym razem, gdy kolega kupi ten szablon.",
  },
  seo: {
    landing_title: "NEURACOM by TelcaVoIP — Platforma AI dla europejskich firm i prawników",
    landing_description: "Zgodny z RODO workspace AI dla europejskich zespołów: chat multi-model, obrazy, głos, code builder, analiza dokumentów. Legal Pro dla włoskich prawników z bazą 103 orzeczeń Sądu Kasacyjnego i TSUE, generatorem pism i marketplace'em.",
    pricing_title: "Cennik — NEURACOM by TelcaVoIP · od darmowego do €149/mies.",
    pricing_description: "Przejrzyste plany miesięczne od bezpłatnego do €149 Legal Pro. Zgodne z RODO, hostowane w UE. Chat, obrazy, głos, kod, orzecznictwo, Atto Generator i dostęp do marketplace'u.",
    marketplace_title: "Marketplace szablonów prawnych — włoskie pisma tworzone przez AI",
    marketplace_description: "Kup lub opublikuj zanonimizowane szablony prawne od włoskich adwokatów. Memoria difensiva, ricorsi Cassazione, pareri, diffide, recessi. Od €19. Anonimizacja AI + weryfikacja autora.",
    jurisprudence_title: "Włoskie i europejskie orzecznictwo — 103 wyroki Cassazione + TSUE",
    jurisprudence_description: "Przeszukiwalna baza 103 wybranych orzeczeń włoskiego Sądu Kasacyjnego i Trybunału Sprawiedliwości UE. Reforma Cartabia, Kodeks Konsumencki, RODO, prawo pracy, umowy.",
  },
  blog: {
    seo_title: "Blog NEURACOM — Kasacja, RODO, Legal AI dla prawników",
    seo_description: "Analizy prawne, komentarze do wyroków i praktyczne przewodniki dla włoskich i europejskich prawników. Kasacja, TSUE, RODO, umowy, workflow Legal Pro. Cotygodniowe aktualizacje.",
    pretitle: "MAGAZYN PRAWNY",
    title: "Analizy, wyroki i playbooki dla nowoczesnej kancelarii.",
    subtitle: "Komentarze do wyroków, praktyczne przewodniki po RODO i umowach, workflow AI dla prawników. Kuratorem NEURACOM by TelcaVoIP.",
    search_ph: "Szukaj artykułów…",
    filter_all: "Wszystkie",
    read_more: "Czytaj artykuł",
    empty_title: "Nie znaleziono artykułów",
    empty_body: "Zajrzyj wkrótce — publikujemy nowe analizy co tydzień.",
    article_singular: "artykuł",
    article_plural: "artykułów",
    notfound_title: "Artykuł nie znaleziony",
    notfound_body: "Artykuł, którego szukasz, nie istnieje lub nie jest już opublikowany.",
    back_to_index: "Powrót do bloga",
    related_title: "Czytaj dalej",
    cta_pretitle: "WYPRÓBUJ NEURACOM LEGAL PRO",
    cta_title: "AI + Orzecznictwo + Atto Generator dla Twojej kancelarii.",
    cta_body: "Claude Opus 4.8, 103 indeksowane wyroki Kasacyjne/TSUE, generator włoskich pism sądowych, osobista Baza Wiedzy. Zgodny z RODO, hostowany w UE.",
    cta_button_pricing: "Zobacz Legal Pro (€149/mies.)",
    cta_button_jurisprudence: "Przeglądaj orzecznictwo",
  },
};

export default pl;
